import { render, staticRenderFns } from "./TagPill.vue?vue&type=template&id=9bd5f41c&"
import script from "./TagPill.vue?vue&type=script&lang=js&"
export * from "./TagPill.vue?vue&type=script&lang=js&"
import style0 from "./TagPill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports